<template>
  <section class="home-hero home-hero--skeleton" aria-label="Carregando destaques">
    <div class="home-hero__image"></div>
    <div class="home-hero__content">
      <span class="home-hero__skeleton-line home-hero__skeleton-line--short"></span>
      <span class="home-hero__skeleton-line home-hero__skeleton-line--title"></span>
      <span class="home-hero__skeleton-line"></span>
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeHeroSkeleton",
};
</script>
